<template>
    <MainLayout>

        <!-- Кнопка добавления -->
        <button class="bot-control" @click="openAddModal">
            Добавить в бота
        </button>

        <!-- Кнопка управления этикетками -->
        <button class="bot-control" @click="goToLabelsSettings">
            Управление этикетками
        </button>

        <!-- Кнопка разметки объявлений Авито -->
        <button class="bot-control" @click="goToAvitoListings">
            Объявления Авито
        </button>

        <!-- Список TG товаров -->
        <div class="tg-products-container">
            <TgProductCardComponent
                v-for="product in products"
                :key="product.id"
                :tg_product="product"
                @edit="openEditModal"
                @delete="deleteProduct"
            />
        </div>

        <!-- Модалка -->
        <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
            <div class="modal-content">
                <TgProductsModifyComponent
                    :is-add="isAdd"
                    :product-data="editingProduct"
                    :available-products="availableProducts"
                    :available-labels="availableLabels"
                    @submit="handleModalSubmit"
                />
            </div>
        </div>

    </MainLayout>
</template>

<script>
import api from '@/api/api';
import MainLayout from '@/components/MainLayout.vue';
import TgProductCardComponent from '@/components/BotSettingsComponents/TgProductCardComponent.vue';
import TgProductsModifyComponent from '@/components/BotSettingsComponents/TgProductsModifyComponent.vue';

export default {
    name: 'BotProductsPage',

    components: {
        MainLayout,
        TgProductCardComponent,
        TgProductsModifyComponent,
    },

    data() {
        return {
            products: [],
            availableProducts: [],
            availableLabels: [],
            showModal: false,
            editingProduct: null,
            isAdd: false,

            // 🔑 ссылка на обработчик кнопки назад
            backButtonHandler: null,
        };
    },

    mounted() {
        this.loadData();
        this.setupTelegramBackButton();
    },

    beforeUnmount() {
        this.cleanupTelegramBackButton();
    },

    methods: {
        /* -------------------- DATA -------------------- */

        async loadData() {
            await Promise.all([
                this.fetchTgProducts(),
                this.fetchAvailableProducts(),
                this.fetchAvailableLabels()
            ]);
        },

        async fetchTgProducts() {
            const { data } = await api.get('/bot_managment/product');
            this.products = data || [];
        },

        async fetchAvailableProducts() {
            const { data } = await api.get('/accounting_system/products');
            this.availableProducts = data || [];
        },

        async fetchAvailableLabels() {
            const { data } = await api.get('/bot_managment/labels');
            this.availableLabels = data || [];
        },

        /* -------------------- CRUD -------------------- */

        async deleteProduct(product) {
            await api.delete(`/bot_managment/product/${product.id}`);
            this.products = this.products.filter(p => p.id !== product.id);
        },

        /* -------------------- MODAL -------------------- */

        openAddModal() {
            this.isAdd = true;
            this.editingProduct = null;
            this.showModal = true;
        },

        openEditModal(product) {
            this.isAdd = false;
            this.editingProduct = product;
            this.showModal = true;
        },

        closeModal() {
            this.showModal = false;
            this.editingProduct = null;
        },

        handleModalSubmit(product, actionType) {
            if (actionType === 'added') {
                this.products.unshift(product);
            }

            if (actionType === 'updated') {
                const index = this.products.findIndex(p => p.id === product.id);
                if (index !== -1) {
                    this.products.splice(index, 1, product);
                }
            }

            // ОБНОВЛЯЕМ список доступных этикеток после изменения
            this.fetchAvailableLabels();
            
            this.closeModal();
        },

        /* -------------------- NAVIGATION -------------------- */

        goToLabelsSettings() {
            this.$router.push({ name: 'LabelsSettingsPage' });
        },

        goToAvitoListings() {
            this.$router.push({ name: 'AvitoListingsPage' });
        },

        /* -------------------- TELEGRAM BACK BUTTON -------------------- */

        handleBackButton() {
            if (this.showModal) {
                this.closeModal();

                // ✅ даём Telegram закончить клик
                setTimeout(() => {
                    window.Telegram?.WebApp?.BackButton?.show();
                }, 0);

                return;
            }

            this.$router.back();
        },



        setupTelegramBackButton() {
            if (!window.Telegram?.WebApp?.BackButton) return;

            const backButton = window.Telegram.WebApp.BackButton;

            this.backButtonHandler = () => {
                this.handleBackButton();
            };

            backButton.onClick(this.backButtonHandler);
            backButton.show();
        },

        cleanupTelegramBackButton() {
            if (!window.Telegram?.WebApp?.BackButton) return;

            const backButton = window.Telegram.WebApp.BackButton;

            if (this.backButtonHandler) {
                backButton.offClick(this.backButtonHandler);
                this.backButtonHandler = null;
            }

            backButton.hide();
        }
    }
};
</script>

<style scoped>
.tg-products-container {
    display: flex;
    flex-direction: column;
    gap: 2vw;
    padding-bottom: 20px;
}

.bot-control {
    width: 100%;
    height: 10vw;
    border-radius: 10px;
    font-size: 18px;
    color: white;
    background-color: #005ADA;
    border: none;
    margin-bottom: 3vw;
    cursor: pointer;
}

.bot-control:active {
    transform: scale(0.97);
}

.modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.modal-content {
    width: 100%;
    max-width: 800px;
    max-height: 90vh;
    border-radius: 16px;
    overflow: hidden;
}
</style>
